package com.eladfinish.bible.contest.ui.menus.actions

import com.eladfinish.bible.contest.screens.completeVerse.menu.ThreeDotsOption
import com.eladfinish.bible.contest.screens.completeVerse.menu.UnderlineOption

sealed interface ToolbarAction

sealed interface MainToolbarAction : ToolbarAction {
    data object Rate : MainToolbarAction
    data object Share : MainToolbarAction
    data object CheckUpdate : MainToolbarAction
    data object ShowAd : MainToolbarAction
    data object AdFreeHour : MainToolbarAction
    data object Upgrade : MainToolbarAction
    data object Help : MainToolbarAction
    data object RestorePurchase : MainToolbarAction
    data object ConsumeTestPurchase : MainToolbarAction
}

sealed interface RandomVerseToolbarAction : ToolbarAction {
    data object NewVerse : RandomVerseToolbarAction
    data object SeveralRandomVerses : RandomVerseToolbarAction
    data object Settings : RandomVerseToolbarAction
}

sealed interface PairMatchingToolbarAction : ToolbarAction {
    data object NewGame : PairMatchingToolbarAction
    data object ShowSolution : PairMatchingToolbarAction
    data object CopyPairs : PairMatchingToolbarAction
    data object CreatePairs : PairMatchingToolbarAction
    data object Refresh : PairMatchingToolbarAction
    data object Settings : PairMatchingToolbarAction
}

sealed interface MikudToolbarAction : ToolbarAction {
    data object SelectAllMaterial : MikudToolbarAction
    data object DeselectAllMaterial : MikudToolbarAction
    data object Help : MikudToolbarAction
    data object ShowMikud : MikudToolbarAction
}

sealed interface MultipleChoiceQuestionsToolbarAction : ToolbarAction {
    data object FiftyFifty : MultipleChoiceQuestionsToolbarAction
    data object Help : MultipleChoiceQuestionsToolbarAction
    data object Refresh : MultipleChoiceQuestionsToolbarAction
    data object Settings : MultipleChoiceQuestionsToolbarAction
}

sealed interface OpenQuestionsToolbarAction : ToolbarAction {
    data object MoreQuestions : OpenQuestionsToolbarAction
    data object TableOfContents : OpenQuestionsToolbarAction
    data object Help : OpenQuestionsToolbarAction
    data object AddQuestion : OpenQuestionsToolbarAction
    data object CreateYourOwnQnA : OpenQuestionsToolbarAction
    data object Refresh : OpenQuestionsToolbarAction
}

sealed interface PyramidCrosswordToolbarAction : ToolbarAction {
    data object Help : PyramidCrosswordToolbarAction
    data object Solutions : PyramidCrosswordToolbarAction
}

sealed interface BrowseToolbarAction : ToolbarAction {
    data object Help : BrowseToolbarAction
    data object OpenBookmark : BrowseToolbarAction
    data object ChangeFontSize : BrowseToolbarAction
    data object LoadSavedCompletions : BrowseToolbarAction
}

sealed interface ChapterContentToolbarAction : ToolbarAction {
    data class AddBookmark(val scrollY: Int, val textOffset: Int) : ChapterContentToolbarAction
    data object ChangeFontSize : ChapterContentToolbarAction
    data object ChooseAliyah : ChapterContentToolbarAction
    data object ShowOnqelos : ChapterContentToolbarAction
    data object TikunKorim : ChapterContentToolbarAction
    data object SaveContent : ChapterContentToolbarAction
}

sealed interface SearchToolbarAction : ToolbarAction {
    data object Help : SearchToolbarAction
    data object History : SearchToolbarAction
    data object PopularSearches : SearchToolbarAction
    data object SelectAll : SearchToolbarAction
    data object Copy : SearchToolbarAction
    data object Paste : SearchToolbarAction
    data object Export : SearchToolbarAction
    data object Stats : SearchToolbarAction
    data object ShareSearch : SearchToolbarAction
    data object CopyAllResults : SearchToolbarAction

    data class TextWithNikud(val checked: Boolean) : SearchToolbarAction
    data class TextWithTeamim(val checked: Boolean) : SearchToolbarAction
    data class TextOnlyQri(val checked: Boolean) : SearchToolbarAction

    sealed interface SearchMode : SearchToolbarAction {
        data object RegularSearch : SearchMode
        data object FirstLastLettersInName : SearchMode
        data object PasukLeHazmana : SearchMode
    }

    sealed interface WhereToSearch : SearchToolbarAction {
        data object ByMikud : WhereToSearch
        data object WholeBible : WhereToSearch
    }
}

sealed interface CompleteVerseToolbarAction : ToolbarAction {

    // Top-level actions
    data object NewVerse : CompleteVerseToolbarAction
    data object Help : CompleteVerseToolbarAction

    data class UnderlineMode(val underlineOption: UnderlineOption) : CompleteVerseToolbarAction
    data class ThreeDotsMode(val threeDotsOption: ThreeDotsOption) : CompleteVerseToolbarAction
}
